import { unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/studio.png'
import _imports_1 from '@/assets/img/down-arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-413db8d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-top-right" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "studio-title" }, "工作室", -1))
const _hoisted_5 = { class: "studioList" }
const _hoisted_6 = ["title", "onClick"]
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "person-select" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "培训中心", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "安全设置", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

import useHomeStore from '@/store/modules/home'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { quit, autoLoginByCASId } from '@/api/index'
import { storeToRefs } from 'pinia'
import location from "@/utils/location";
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';

export default {
  __name: 'login-register',
  setup(__props) {

const domain = location.domain();
const homeStore = useHomeStore()
const route = useRoute()
const router = useRouter()
const { showLogin, isLogin, userInfo, roleTypeId, roleId, studioList, academicStage, subject, stageAndsubject, current, homepageList, defaultTab, showStudioList, showPersonSelect, memberId } = storeToRefs(homeStore)

// const showPersonSelect = ref(false)
const personClick = () => {
  showPersonSelect.value = !showPersonSelect.value
}

const clickLogin = () => {
  showLogin.value = true
}

//退出
const loginOut = async () => {
  const res = await quit()
  if (res.code == 0) {
    homeStore.quitClearData()
    // 未登录如果清除下面的数据会造成 切换路由学段学科重置
    stageAndsubject.value = '全部学科'
    academicStage.value = {}
    subject.value = {}
    memberId.value = ''
    // sessionStorage.removeItem('userInfo')
    // userInfo.value = {}
    // isLogin.value = false

  }
  // 如果是在首页点的退出
  // if (route.path.includes('index')) {
  //   current.value = 1
  //   homepageList.value = []
  //   homeStore.getHomepageList()
  // }
  // 如果是在个人中心点的退出
  if (route.path.includes('personSpace')) {
    defaultTab.value = 0
    router.push('/home/index')
    return
  } else {
    const paramsObj = { ...route.query };
    delete paramsObj['token'];
    router.push({
      path: route.path,
      params: paramsObj
    })
  }
  // router.go(0);
}

// 点击空白处隐藏 登录下拉
const personRef = ref()
const userClickOutside = (e) => {
  if ((personRef.value && personRef.value.contains(e.target))) {
    // console.log('包含不处理')
  } else {
    // console.log('不包含隐藏')
    showPersonSelect.value = false
  }
}
// 点击空白隐藏 工作室下拉
const studioRef = ref()
const userClickOutside1 = (e) => {
  if (studioRef.value && !studioRef.value.contains(e.target)) {
    showStudioList.value = false
  }
}
onMounted(() => {
  document.addEventListener("click", userClickOutside);
  document.addEventListener("click", userClickOutside1);
})

onBeforeUnmount(() => {
  document.removeEventListener("click", userClickOutside);
  document.removeEventListener("click", userClickOutside1);
})


//去个人中心
const goPersonCenter = () => {
  window.open(
    domain +
    `personCenter/index.html#/master/index?memberId=${memberId.value}`
  );
}

//去安全设置
const goSetting = () => {
  window.open(`${domain}personCenter/index.html#/master/security?roleTypeId=${roleTypeId.value}&roleId=${roleId.value}`);
}

//去工作室
const goStudio = (val) => {
  autoLoginByCASId({projectId: val.id}).then(res => {
    if (res.success) {
      window.open(`${domain}studyPlace/index.html#/?projectId=${val.id}`);
    } else {
      ElMessage.error(res.msg);
    };
  });
}

//点击注册
const clickRegister = () => {
  // window.open(`${domain}register`)
  window.open(`${domain}/index.html#/register?toUrl=${window.location.href}`)
}

//点击工作室 

const clickStudio = () => {
  // 新增需求 当用户只有一个项目时，可点击工作室按钮直接进入，不必再展示二级菜单
  if(studioList.value.length ==1){
    goStudio(studioList.value[0])
  }else{
    showStudioList.value = !showStudioList.value

  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(homeStore).isLogin)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: "login curPointer",
            onClick: clickLogin
          }, "登录 "),
          _hoisted_2,
          _createElementVNode("div", {
            class: "curPointer",
            onClick: clickRegister
          }, "注册")
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(studioList).length>0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "studio",
                ref_key: "studioRef",
                ref: studioRef,
                onClick: clickStudio
              }, [
                _hoisted_3,
                _hoisted_4,
                _withDirectives(_createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(studioList), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "studio-item",
                      key: index,
                      title: item.name,
                      onClick: $event => (goStudio(item))
                    }, _toDisplayString(item.name), 9, _hoisted_6))
                  }), 128))
                ], 512), [
                  [_vShow, _unref(showStudioList)]
                ])
              ], 512))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "htr-person",
            onClick: personClick,
            ref_key: "personRef",
            ref: personRef
          }, [
            _createElementVNode("span", {
              class: "htr-person-name",
              title: _unref(userInfo).realName 
            }, "您好，" + _toDisplayString(_unref(userInfo).realName), 9, _hoisted_7),
            _hoisted_8,
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "person-item",
                onClick: goPersonCenter
              }, _hoisted_12),
              _createElementVNode("div", {
                class: "person-item setting",
                onClick: goSetting
              }, _hoisted_15),
              _createElementVNode("div", {
                class: "person-item quit",
                onClick: loginOut
              }, _hoisted_18)
            ], 512), [
              [_vShow, _unref(showPersonSelect)]
            ])
          ], 512)
        ], 64))
  ]))
}
}

}